import { Table } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { NumberFormatter, Text } from 'components';
import { CreditPreviousRequestOverview, CreditStatus } from 'types';
import { AppUtils } from 'utils';

const STATUS_COLORS: Partial<Record<CreditStatus, string>> = {
  SETTLED: 'grape.7',
  REJECTED: 'red.6',
  REJECTED_WK_TEAM: 'red.6',
  WITHDRAWN: 'yellow.6',
  DISBURSED: 'green.6',
};

interface PreviousCreditRequestRowProps {
  request: CreditPreviousRequestOverview;
  onClick: () => void;
}

export const PreviousCreditRequestRow = ({ request, onClick }: PreviousCreditRequestRowProps) => {
  const {
    id,
    status,
    bank,
    statusChangedAt,
    grantedCreditAmount,
    grantedInstallmentAmount,
    securedLoanInstallment,
  } = request;
  const { t } = useTranslation();

  return (
    <Table.Tr
      bg={'gray.1'}
      c={'gray.7'}
      style={{ borderBottom: '0.5px solid var(--mantine-color-gray-5)' }}
    >
      <Table.Td>{id}</Table.Td>
      <Table.Td>
        {!!status && (
          <Text
            c={STATUS_COLORS[status]}
            onClick={onClick}
            td="underline"
            style={{ cursor: 'pointer' }}
          >
            {t(`credit.status.name.${status}`)}
          </Text>
        )}
      </Table.Td>
      <Table.Td>{!!bank && t(`credit.bank.options.${bank}`)}</Table.Td>
      <Table.Td>{AppUtils.convertToAppropriateValue(new Date(statusChangedAt))}</Table.Td>
      <Table.Td>
        <NumberFormatter value={grantedCreditAmount} />
      </Table.Td>
      <Table.Td>
        <NumberFormatter value={grantedInstallmentAmount} />
      </Table.Td>
      <Table.Td>
        {securedLoanInstallment && <IconCheck size={20} color="var(--mantine-color-green-7)" />}
      </Table.Td>
    </Table.Tr>
  );
};
